import React from 'react';
import { IconButton, Tooltip } from '@mui/material';

const ActionIconButton = ({ title, children, tooltipPlacement = 'top', ...props }) => {
  return (
    <Tooltip title={title || ''} placement={tooltipPlacement}>
      <span>
        <IconButton {...props}>
          {children}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default ActionIconButton;
